import React from "react"

const IconLight = () => {
   return (
      <svg
         xmlns="http://www.w3.org/2000/svg"
         width="24"
         height="24"
         viewBox="0 0 24 24"
      >
         <path d="M4.069 13H0v-2h4.069c-.041.328-.069.661-.069 1s.028.672.069 1zm3.034-7.312L4.222 2.807 2.808 4.221l2.881 2.881a8.019 8.019 0 011.414-1.414zm11.209 1.414l2.881-2.881-1.414-1.414-2.881 2.881a8.121 8.121 0 011.414 1.414zM12 4c.339 0 .672.028 1 .069V0h-2v4.069A8.047 8.047 0 0112 4zm0 16c-.339 0-.672-.028-1-.069V24h2v-4.069A8.047 8.047 0 0112 20zm7.931-9c.041.328.069.661.069 1s-.028.672-.069 1H24v-2h-4.069zm-3.033 7.312l2.88 2.88 1.415-1.414-2.88-2.88a8.127 8.127 0 01-1.415 1.414zm-11.21-1.415l-2.88 2.88 1.414 1.414 2.88-2.88a8.053 8.053 0 01-1.414-1.414zM8 12c0 2.206 1.794 4 4 4s4-1.794 4-4-1.794-4-4-4-4 1.794-4 4zm10 0a6 6 0 11-12 0 6 6 0 0112 0z"></path>
      </svg>
   )
}

export { IconLight as default }
